// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"jgp-2qek5","image":"jgp-3gcxE","title":"jgp-1yGqC","bidding_alert":"jgp-BrNBU","description":"jgp-2NawD","bidding":"jgp-1A2-o","bid":"jgp-3jIBN","button":"jgp-3fXuF"};